var TorsoFormModel = require('backbone-torso/modules/FormModel');

/**
 * Form Model for Patient Portal Settings Password Form
 * @class PatientSettingsPasswordFormModel
 * @extends TorsoFormModel
 */

var PatientSettingsPasswordFormModel = TorsoFormModel.extend({
  mapping: {
    portalUserModel: 'newPassword confirmPassword'
  },

  /**
   * The validation rules for this form model
   * @property validation
   */
  validation: {
    newPassword: {
      requiredField: 'true'
    },
    confirmPassword: {
      requiredField: 'true',
      fn: function(confirmPassword) {
        var password = this.get('newPassword');
        if (confirmPassword && confirmPassword !== password) {
          return {
            key: 'error.match'
          };
        }
      }
    }
  }
});

module.exports = PatientSettingsPasswordFormModel;
